// ============================================================================
// EduPath Sprint 5 - Sync Toast Notification
// ============================================================================
// Lightweight toast component for sync status updates.
// ============================================================================

import React from 'react';
import { useOfflineSync } from '@/hooks/useOfflineSync';

const toastStyles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    top: '16px',
    right: '16px',
    zIndex: 3000,
    maxWidth: '360px',
    animation: 'ep-toast-slide 0.3s ease-out',
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 16px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    fontSize: '13px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    cursor: 'pointer',
  },
  success: {
    background: '#ecfdf5',
    color: '#065f46',
    border: '1px solid #a7f3d0',
  },
  error: {
    background: '#fef2f2',
    color: '#991b1b',
    border: '1px solid #fecaca',
  },
  info: {
    background: '#eff6ff',
    color: '#1e40af',
    border: '1px solid #bfdbfe',
  },
};

const toastIcons: Record<string, string> = {
  success: '✓',
  error: '✗',
  info: 'ℹ',
};

export const SyncToast: React.FC = () => {
  const { toastMessage, clearToast } = useOfflineSync();

  if (!toastMessage) return null;

  return (
    <>
      <style>{`
        @keyframes ep-toast-slide {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      <div style={toastStyles.container} onClick={clearToast}>
        <div
          style={{
            ...toastStyles.toast,
            ...toastStyles[toastMessage.type],
          }}
        >
          <span style={{ fontSize: '16px', fontWeight: 700 }}>
            {toastIcons[toastMessage.type]}
          </span>
          <span>{toastMessage.text}</span>
        </div>
      </div>
    </>
  );
};

export default SyncToast;
